
export const staffAndPlantList = [
    {
      title: "Staff List",
      path: "staffList",
      image: "/staffList.png",
    },
    {
      title: "Plant List",
      path: "plantList",
      image: "/plantList.png",
    },
    // {
    //   title: "Work Hours",
    //   path: "workHour",
    //   image: "/workHour.png",
    // },
  ];